import React, { Component } from 'react';
import Text from './Text';
import { NavLink } from 'react-router-dom';

const publicPath = "/";

const DataDescription = <div id="Descript">


Welcome to part 2, here we will do all the necessary data transformations to run the model in part 3.<br/><br/>

Before proceeding, the code, data, charts and trained models are on my <a href="https://github.com/JRachadell/Bitcoin_Deep_Learning">github</a>. Here you will find two type of files:
"Create your own model" to train your own neural networks and "Load TheCryptosDB Model" to use previously trained neural networks and just change the trading strategies.
If you train your own neural networks, the results will never be equal to mine because there are many aspects that randomize the results, for example using GPU.
In the case that you load one of my previously trained models, the results will be exactly the same if you use the same parameters.<br/><br/>

Go to <a href="https://www.coindesk.com/price/">Coindesk</a> and above the chart press "All", then Export -> Download CSV Chart Data.
Rename the downloaded file to 'btc.csv' and if you are using a project, place the file in your project's root directory.
If you don't create a project, also save it as 'btc.csv' and write down the file's directory because you will need access to it later.
After importing the libraries we need (the ones used in part 1), we will set up the max numbers of rows to see in pandas,
variables like the seeds for random numbers,
tensorflow’s min level and some warnings that won't be necessary.<br/><br/>
<code>
pd.options.display.max_rows = 100<br/>
np.random.seed(1)<br/>
set_random_seed(1)<br/>
rn.seed(1)<br/>
os.environ['TF_CPP_MIN_LOG_LEVEL'] = '3'<br/>
warnings.filterwarnings("ignore")
</code>
<br/><br/>

Proceed to load the data to a pandas dataframe,
sort the dataframe by date and delete the last rows because CoinDesk includes the value at the time you downloaded the data and some extra info. 
If you are not using a python project, replace 'btc.csv' with the full directory of your file, for example:
'/home/user/files/btc.csv' or 'C:/users/user/downloads/btc.csv'<br/><br/>
<code>
df = pd.read_csv('btc.csv')<br/>
df = df.sort_values(by='Date')<br/>
df = df.drop(len(df)-1, axis=0)<br/>
df = df.drop(len(df)-1, axis=0)
</code>
<br/><br/>

Next we convert the “Date” column to actual dates because they are strings (raw text).
In date format we can compare dates between each other.
We want the date column in the index to replace the current one and then drop that column.<br/><br/>

<code>
df['Date'] = [parser.parse(x) for x in list(df['Date'])]<br/>
df.index = df['Date']<br/>
df = df.drop('Date', axis=1)
</code>
<br/><br/>

To make things simpler, rename the column “Close Price” to “Price”
and also drop the first 800 rows because they are pretty different from the rest of the data
(low price and VERY high volatility) and that could affect the model.
The last line will drop all the observations after 2018-03-19 because I'm using data up to that date.<br/><br/>

<code>
df = df.rename(columns=	&#123;'Close Price': 'Price'&#125;)<br/>
df = df[800:]<br/>
df = df[df.index &#60; datetime(2018, 3, 20)]
</code>
<br/><br/>

Here we decide how many observations we want the model to use to predict the next value and then use the scaler imported from SKLearn to scale the data.
I will use 20 but feel free to change the number if you want to experiment a little.<br/><br/>

<code>
Obs = 20<br/>
sc = StandardScaler()<br/>
df['Price'] = sc.fit_transform(df['Price'].reshape(-1, 1))
</code>
<br/><br/>
Now is time for the final transformations before writing the neural network.
First, the column “Price” is transformed to a numpy array and then to a two dimensional numpy array. 
Second, the shape of the array that is 1xN will be transposed to make it Nx1.
Many of these transformations are Keras requirements to run the model.<br/><br/>

<code>
Data = np.asarray(df['Price'])<br/>
Data = np.atleast_2d(Data)<br/>
Data = Data.T
</code>
<br/><br/>

The last thing we need is to split the data in two groups: “X” and “y” (this names are by convention).
For every value that we want to forecast we need the prior n observations.
Imagine that these are the historic prices: 1, 2, 3, 4, 5, 6, 7, 8 and we want to use the prior 6 observations to make each forecast.<br/>

<br/>
The max number of values we can forecast is 2 (8 prices – 6 prior observations) and those are the last two values 7, 8.
Those are the values in “y”. For every value in y, we need to create an array and put it in “X”.
To forecast the value 7, the array is the prior 6 values: 1, 2, 3, 4, 5, 6 and for 8 it is 2, 3, 4, 5, 6, 7.<br/>
<br/>

The final “y” array = [7, 8] and the final “X” array is a group of arrays:
[[1, 2, 3, 4, 5, 6,], [2, 3, 4, 5, 6, 7]].<br/>
This is VERY important to understand because that is what the model will get as input (“X”) and what it will try to predict as output (“y”). 
After understanding that, we proceed to create “X” and “y” with real data.<br/>
“X” is created with many groups of n observations from the data.<br/>
“y” is created using the original data minus the n prior observations like we did with the example before.<br/>
To check if everything is ok we print how long “X” and “y” are, they should have the same length.<br/><br/>
<code>
X = np.atleast_3d(np.array([Data[start:start + Obs] for start in range(0, Data.shape[0] - Obs)]))<br/>
y = Data[Obs:]<br/>
print len(X), len(y)
</code>
<br/><br/>
The output should be: <br/>
<mark> 1982 1982 </mark><br/><br/>
If you don't have any errors, you are ready for <NavLink to={`${publicPath}model`}>Part 3: Designing And Running The Model</NavLink>.
</div>;

class Data extends Component {


  componentDidMount() {
    window.onscroll = function() {scrollFunction()};

    function scrollFunction() {
        if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
            document.getElementById("myBtn").style.display = "block";
        } else {
            document.getElementById("myBtn").style.display = "none";
        }
    }

    function findPos(obj) {
      var curtop = 0;
      if (obj.offsetParent) {
        while (obj = obj.offsetParent) {
              curtop += obj.offsetTop;
          };
      return [curtop];
      }
    }

    document.getElementById("myBtn").onclick = function() {
      const   scrollHeight = window.scrollY,
              scrollStep = Math.PI / ( 1000 / 15 ),
              cosParameter = scrollHeight / 2;
      var     scrollCount = 0,
              scrollMargin,
              scrollInterval = setInterval( function() {
                  if ( window.scrollY > 10 ) {
                      scrollCount = scrollCount + 1;  
                      scrollMargin = cosParameter - cosParameter * Math.cos( scrollCount * scrollStep );
                      window.scrollTo( 0, ( scrollHeight - scrollMargin ) );
                  } 
                  else clearInterval(scrollInterval); 
              }, 15 );
    }

    const scrollHeight = window.scrollY - findPos(document.getElementById("myNavbar"))[0],
    scrollStep = Math.PI / ( 1000 / 15 ),
    cosParameter = scrollHeight / 2;
    var scrollCount = 0,
    scrollMargin,
    scrollInterval = setInterval( function() {
        if ( window.scrollY - findPos(document.getElementById("myNavbar"))[0] > 10 ) {
            scrollCount = scrollCount + 1;  
            scrollMargin = cosParameter - cosParameter * Math.cos( scrollCount * scrollStep );
            window.scrollTo( 0, ( scrollHeight - scrollMargin ) );
        } 
        else clearInterval(scrollInterval); 
    }, 15 );
  }

  render() {
    return (
        <div id="Data">
        <h1>Part 2: Preparing The Data</h1>
          <Text Searchable="Time" description={DataDescription}/>
        </div>
    );
  }
}

export default Data;



// WEBPACK FOOTER //
// ./src/components/Data.js